// eslint-disable-next-line import/no-extraneous-dependencies
import { VuePDF, usePDF } from '@tato30/vue-pdf';

export default () => ({
    VuePDF,
    usePDF,
});
